import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChangePasswordRoutingModule } from './change-password-routing.module';
import { ChangePasswordComponent } from './change-password.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AuthService } from '../auth/auth.service';
import { LoadingModule } from 'ngx-loading';
import { SharedModule } from '../shared/shared.module';

@NgModule({
  imports: [
    CommonModule,
    ChangePasswordRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    LoadingModule
  ],
  declarations: [ChangePasswordComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [AuthService]
})
export class ChangePasswordModule { }


// WEBPACK FOOTER //
// ./src/app/change-password/change-password.module.ts